import { format as d3Format } from "d3-format";

const D3Format = {
  install(Vue) {
    const format = (number, fmt) => {
      return d3Format(fmt)(number);
    };
    Vue.filter("d3_format", format);

    Vue.prototype.$d3 = {
      format
    };
  }
};

export default D3Format;
